export default __webpack_public_path__ + "static/media/whatsapp.704262dd.svg";